/**
 * 小程序-图片评论
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>图片评论</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" ref="formInline" class="user-search">
      <el-form-item label="搜索：" prop="name">
        <el-input size="small" v-model="formInline.name" placeholder="输入昵称"></el-input>
      </el-form-item>
      <el-form-item label="" prop="content">
        <el-input size="small" v-model="formInline.content" placeholder="输入评论内容"></el-input>
      </el-form-item>
      <el-form-item prop="isdelete">
        <el-select size="small" v-model="formInline.isdelete" placeholder="是否删除">
          <el-option v-for="type in isdelete" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="resetForm('formInline')">重置</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="cid" label="主键" v-if="false" width="200" show-overflow-tooltip>
      </el-table-column>
      
      <el-table-column sortable prop="avatarurl" label="头像" width="70" show-overflow-tooltip>

        <template slot-scope="scope">
            <el-popover placement="top-start" title="" trigger="hover">
              <img :src="scope.row.avatarurl" alt="" style="width: 150px;height: 150px">
              <img slot="reference" :src="scope.row.avatarurl" style="width: 40px;">
            </el-popover>
        </template>
        <!-- <template slot-scope="scope">
          <el-image style="width: 100%; height: 100px" :src="scope.row.avatarurl" :preview-src-list="[scope.row.avatarurl]" :key="scope.row.cid">
            <div slot="error" class="image-slot">
               <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </template> -->

      </el-table-column>

      <el-table-column sortable prop="nickname" label="昵称" width="180" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="content" label="评论内容" width="400" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="theme_name" label="所属模块" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="createtime" label="评论时间" width="150" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="isdelete" label="是否删除" width="100" show-overflow-tooltip>
        <template slot-scope="{row}">
            <div style="color:red;" v-if="row.isdelete == 1">
                是
            </div>
            <div v-else>
                否
            </div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteUser(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog('editForm')">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="主键" v-if="false">
          <el-input  v-model="editForm.cid" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="用户昵称" prop="nickname">
          <el-input size="small" v-model="editForm.nickname" :disabled="title == '修改'" auto-complete="off" placeholder="请输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="头像" prop="avatarurl">
          
          <template v-if="!this.showImg">
            <el-image style=" height: 100px" :src="editForm.avatarurl" :preview-src-list="[editForm.avatarurl]" :key="editForm.cid">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </template>
        
          <el-input v-if="this.showImg" size="small" v-model="editForm.avatarurl" auto-complete="off" placeholder="请输入头像链接"></el-input>
        
        </el-form-item>
        <el-form-item label="所属模块" prop="theme_name">
          <el-input size="small" v-model="editForm.theme_name" auto-complete="off" placeholder="请选择所属模块"></el-input>
        </el-form-item>
        <el-form-item label="评论内容" prop="content">
          <el-input type="textarea" size="small" v-model="editForm.content" :disabled="title == '修改'" auto-complete="off" placeholder="请输入评论内容"></el-input>
        </el-form-item>
        <el-form-item label="评论时间" prop="createtime">
          <!-- <el-input size="small" v-model="editForm.createtime" auto-complete="off"></el-input> -->
          <el-date-picker v-model="editForm.createtime" type="datetime" :disabled="title == '修改'" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item label="是否删除" prop="isdelete">
          <el-radio v-model="editForm.isdelete" label="1">是</el-radio>
          <el-radio v-model="editForm.isdelete" label="0">否</el-radio>
        </el-form-item>
      
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('editForm')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CommentList, CommentSave } from '../../api/businessMG'
import Pagination from '../../components/Pagination'
import {dateFormat} from '../../utils/datetime'
export default {
  data() {
    return {
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      showImg: false,
      isdelete: [
        { key: '是', value: 1 },
        { key: '否', value: 0 },
      ],
      editForm: {
        cid: '',
        nickname: '',
        avatarurl: '',
        content: '',
        theme_name: '',
        themeId: '',
        createtime: '',
        isdelete: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
        avatarurl: [
          { required: false, message: '请输入头像链接', trigger: 'blur' }
        ],
        content: [{ required: true, message: '请输入评论内容', trigger: 'blur' }],
        
      },
      formInline: {
        page: 1,
        limit: 10,
        name: '',
        isdelete: '',
        content: '',
        Token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取数据列表
    getdata(parameter) {
      this.loading = true
      CommentList(parameter)
        .then(res => {
          this.loading = false
          if (res.result != 'success') {
            this.$message({
              type: 'info',
              message: '请求失败'
            })
          } else {
            this.listData = res.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$message.error(err.response.statusText)
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      // this.$message({
      //   type: 'success',
      //   message: '这是一个小提示'
      // })
      this.formInline.page = 1
      this.getdata(this.formInline)
    },
    //重置
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.showImg = false
        this.title = '修改'
        this.editForm.cid = row.cid
        this.editForm.nickname = row.nickname
        this.editForm.avatarurl = row.avatarurl
        this.editForm.content = row.content
        this.editForm.theme_name = row.theme_name
        this.editForm.createtime = row.createtime
        this.editForm.isdelete = row.isdelete
      } else {
        this.showImg = true
        this.title = '新增'
        this.editForm.cid = ''
        this.editForm.nickname = ''
        this.editForm.avatarurl = ''
        this.editForm.content = ''
        this.editForm.theme_name = ''
        this.editForm.createtime = dateFormat(new Date())
        this.editForm.isdelete = '0'
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          CommentSave(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.success) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '评论保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('评论保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 删除公司
    deleteUser(index, row) {
      this.$confirm('确定要删除吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          CommentDelete(row.deptId)
            .then(res => {
              if (res.success) {
                this.$message({
                  type: 'success',
                  message: '公司已删除!'
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('支付配置信息删除失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/miniBusiness/CommentAll.vue